import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
      fill: 'white',
    },
  };
});

const RouteStatusLockedIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path d="M12.191 1.44C18.023 1.44 22.751 6.168 22.751 12C22.751 17.832 18.023 22.56 12.191 22.56C6.35901 22.56 1.63101 17.832 1.63101 12C1.63101 6.168 6.35901 1.44 12.191 1.44ZM12.191 0C5.56701 0 0.19101 5.376 0.19101 12C0.19101 18.624 5.56701 24 12.191 24C18.815 24 24.191 18.624 24.191 12C24.191 5.376 18.815 0 12.191 0Z" />
      <path d="M16.6895 12.2647C16.6739 12.0936 16.549 11.9243 16.3873 11.862C16.203 11.7908 16.0171 11.725 15.8303 11.6634V9.54768C15.83 7.59124 14.1977 6 12.1911 6C10.1843 6 8.55203 7.59124 8.55203 9.54768V11.6633C8.36519 11.7248 8.17934 11.7907 7.99501 11.8619C7.83298 11.9246 7.70829 12.0936 7.69268 12.2646H7.69101V12.3006V12.3687V16.7802C7.69101 16.9633 7.82183 17.1521 7.99487 17.2191C9.33628 17.7371 10.7482 18 12.1911 18C13.6338 18 15.0457 17.7371 16.387 17.2191C16.5605 17.1518 16.691 16.9633 16.691 16.7802V12.3689V12.3007V12.2647H16.6895ZM12.6869 14.3908V15.9884C12.6869 16.2552 12.4651 16.4712 12.191 16.4712C11.9172 16.4712 11.6954 16.2552 11.6954 15.9884V14.3908C11.4048 14.2231 11.1999 13.9268 11.1999 13.573C11.1999 13.0391 11.6436 12.607 12.1909 12.607C12.7384 12.607 13.1822 13.0389 13.1822 13.573C13.1823 13.9268 12.9775 14.2231 12.6869 14.3908ZM14.5787 11.327C13.7971 11.1635 12.9989 11.0809 12.1909 11.0809C11.3829 11.0809 10.5848 11.1635 9.80315 11.327V9.54768C9.80315 8.26407 10.8741 7.21964 12.1907 7.21964C13.5076 7.21964 14.5787 8.26407 14.5787 9.54768V11.327Z" />
    </SvgIcon>
  );
};

export default memo(RouteStatusLockedIcon);
